<template>
  <div
    class="order-kanban-item"
    @click="$emit('click', item.id)"
    data-no-dragscroll
  >
    <div
      class="
        text-right
        d-flex
        justify-content-between
        order-kanban-item__header
      "
      data-no-dragscroll
    >
      <div class="" data-no-dragscroll>
        #{{ item.id }}
      </div>
      <div class="" data-no-dragscroll>
        <b-overlay spinner-small :show="item.loading_sales_manager === true" v-if="!noNames">{{
          salesManagerName
        }}</b-overlay>
      </div>
      <div data-no-dragscroll class="text-primary">
        {{ item.realization_at | formattedDateTime }}
      </div>
    </div>
    <!-- <div class="order-kanban-item__substatuses mb-2" data-no-dragscroll v-html="servicesSubs()"></div> -->
    <div
      class="pb-2 position-relative"
      data-no-dragscroll
    >
      <div
        v-if="!!item.title && item.title !== 'null'"
        class="special_title my-2"
        data-no-dragscroll
      >
        {{ item.title }}
      </div>
      <div class="info-task-two font-size-12 mt-2" v-if="item.company_id">
        <div>
          <span class="text-brown">Клиент: {{ item.company.name }}</span>
        </div>
      </div>
      <div class="info-task-two font-size-12 mt-2" v-if="item.order_id">
        <div>
          <span class="text-brown">Заказ: #{{ item.order_id }}
            <span class="text-success text-uppercase font-weight-bold" v-if="item.order.reference_status_id == 421">(Закрыт)</span>
					<span class="text-danger text-uppercase font-weight-bold" v-if="item.order.reference_status_id == 362">(Отказ)</span>
          </span>
        </div>
      </div>
      <div class="info-task-two font-size-12" v-if="item.order && !item.company_id">
        <div>
          <span class="text-brown">Клиент: {{ item.order.company ? item.order.company.name : item.order.temp_name }}</span>
        </div>
      </div>
      <div class="info-task-two font-size-12 mt-2" v-if="item.finance_id">
        <div>
          <span class="text-brown">Счет: {{ item.finance.invoice_number ? '#' + item.finance.invoice_number : 'номер не задан' }}</span>
        </div>
      </div>
      <div class="info-task-two font-size-12 mt-2" v-if="item.realizators">
        <div>
          <span class="text-brown">Исполнители: {{ sumRealizators(item.realizators) }}</span>
        </div>
      </div>
      <span class="calendar-task-small-icon" title="Задача завершена" v-if="item.reference_status_id == 403">✓</span>                
      <span class="calendar-task-small-icon" title="Задача на проверке" v-if="item.reference_status_id == 402">👁</span>
      <span class="calendar-task-small-icon" title="Задача в работе" v-if="item.reference_status_id == 401">✐</span>
    </div>    
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    noNames: { 
      type: Boolean, 
      default: false 
    },  // need names in cards or not
  },

  computed: {
    salesManagerName() {
      return (
        (this.item.optional_sales_manager &&
          this.item.optional_sales_manager.name) ||
        (this.item.creator && this.item.creator.name)
      );
    },
  },
  methods: {
    servicesSubs() {
      let TO = false;
      let TEO = false;
      let variantTO = 'secondary';
      let variantTEO = 'secondary';
      let output = '';
      this.item.selected_services.forEach((service) => {
        if (service.id === 23) {
            TEO = true;
        } else {
            TO = true;
        }
      })

      this.item.order_substatuses.forEach((substatus) => {
          if (substatus.reference_substatus_id === 553) {
              variantTO = 'success';
          } else if (substatus.reference_substatus_id === 554) {
              variantTEO = 'success';
          }
      })

      if (TO) {
          output = `<span class="badge badge-${variantTO} ml-1">ТО</span>`;
      }
      if (TEO) {
          output += `<span class="badge badge-${variantTEO} ml-1">ТЭО</span>`;
      }

      return output
    },
    sumRealizators(realizators) {
      return realizators.map(u => u.name).join(', ');
    }
  }
};
</script>

<style lang="scss" scoped src="~/components/orderKanban/OrderKanbanItem.scss" />
